/*All Submission Page*/
import Service from "../Service/http";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import { FadeLoader } from "react-spinners";

function ResultTable(prop){

  const {id} = useParams();
  let service = new Service();
  let [data, setData] = useState([]); /*Table data*/
  let [verdict, setVerdict] = useState('');

  const originalWarn = console.warn;
  console.warn = function (...args) {
      const arg = args && args[0];
      if (arg && arg.includes('Attempting to load version \'51\' of Google Charts')) return;
      originalWarn(...args);
  };

  const [isLoading, setLoading] =useState(true);

  const getDelay = (time) => {
    return new Promise(resolve => setTimeout(resolve, time));
  }
  
  const getSubStatus = async (id) =>{
    let attempts = [0,1,2,3,4,5,6,7,8,9];
    let st = true;
    try{
      for await (const attempt of attempts){
      if (attempt==0){
        await getDelay(5000);
      }
      let json = await service.get("api/result/"+id);
      let result =[]
      let ind = 1;
      console.log(json);
      for await (const ele of json[0]["test_results"]){
        result.push({'no':ind, 'verdict':ele['verdict']});
        ind++;
      };
      if (result.length != 0){
        setData(result);
        setVerdict(json[0]['verdict_string'])
        st = false;
        break;
      }
      await getDelay(10000);
      }
      if (st == true){
        alert("Failed to get result please try again later");
      }
    }
    catch(err){
      alert("Failed to get result please try again later");
    }
    setLoading(false);
  }

  useEffect(() => {
    getSubStatus(id);
  }, []);
 
  return (
    <div className="">
      <div className="modal fade" id="graphModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl" width={ window.innerWidth}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">User Activity on Coding Platforms</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
            </div>
          </div>
        </div>
      </div>
      <div>{isLoading?<div className="text-center" style={{marginTop:"17%"}}><FadeLoader color={"green"}/></div>: data.length === 0? <span style={{color:"#E43D40", fontWeight:'bold', fontSize:'30px', alignContent:'center', marginLeft: '35%', marginTop: '15%'}}>Failed to get results please try again later</span> :
  <div><br/><br/><br/><p className="text-center"><span style={{color: verdict==='ACCEPTED' ? "#76B947" : "#E43D40", fontWeight:'bold', fontSize:'30px'}} >{verdict}</span><br/>
  <Table striped bordered hover size='sm' className="p-0" style={{width:'30%', alignContent:'center',marginLeft: '35%', marginTop: '5%'}}>
      <thead>
        <tr>
          <th>Test Case No.</th>
          <th style={{textAlign:'center'}}>Test Case Result</th>
        </tr>
      </thead>
      <tbody>
      {data.map((ele, ind) => {
                      return (
                        <tr key={ind} className="p-0 mt-5">
                          <td style={{width:'30%',textAlign:'center'}}>{ele.no}</td>
                          <td style={{textAlign:'center', backgroundColor:  ele.verdict==='ACCEPTED' ? "#76B947" : "#E43D40"}}>
                          <span> {ele.verdict}</span>
                          </td>
                        </tr> 
                      );
                    })}
      </tbody>
    </Table></p>
    </div>
}</div>
    </div>
  );
}
export default ResultTable;